/**
 * Created by luka on 28.02.2018.
 */
import React from 'react';
import {
    CHEATED,
    CONFIRMED, CURRENT_CONFIRMED, CURRENT_PAUSE, CURRENT_PENDING, MISSED, PAUSE, PAUSE_CONFIRMED, PENDING, SUSPICIOUS,
    TOMORROW,
    TOMORROW_PAUSE
} from "./DayStates";
import {CircularProgress} from 'material-ui/Progress';
import PauseCircleOutline from 'material-ui-icons/PauseCircleOutline';
import Visibility from 'material-ui-icons/Visibility';
import LockOutline from 'material-ui-icons/LockOutline';
import PanoramaFishEye from 'material-ui-icons/PanoramaFishEye';
import HighlightOff from 'material-ui-icons/HighlightOff';
import ErrorOutline from 'material-ui-icons/ErrorOutline';
import SentimentDissatisfied from 'material-ui-icons/SentimentDissatisfied';
import Done from 'material-ui-icons/Done';

export default class SelectableIcon extends React.Component {
    render() {
        if(this.props.loading) {
            return (<CircularProgress style={styles.loadingIndicator} size={24}/>)
        }else {
            switch (this.props.day.state) {
                case PAUSE_CONFIRMED:
                    return (<PauseCircleOutline color='primary' style={styles.stateIcon}/>);
                case TOMORROW_PAUSE:
                    return (<PauseCircleOutline color='disabled' style={styles.stateIcon}/>);
                case TOMORROW:
                    return (<Visibility color='disabled' style={styles.stateIcon}/>);
                case CURRENT_PAUSE:
                    return (<PauseCircleOutline color='primary' style={styles.stateIcon}/>);
                case PAUSE:
                    return (<PauseCircleOutline color='disabled' style={styles.stateIcon}/>);
                case MISSED:
                    if (this.props.day.forgiven) {
                        return (<ErrorOutline color='error' style={styles.stateIcon}/>);
                    } else {
                        return (<HighlightOff color='error' style={styles.stateIcon}/>);
                    }
                case CHEATED:
                    return (<SentimentDissatisfied color='error' style={styles.stateIcon}/>);
                case SUSPICIOUS:
                    return (<Done color='error' style={styles.stateIcon}/>);
                case CURRENT_CONFIRMED:
                case CONFIRMED:
                    return (<Done color='primary' style={styles.stateIcon}/>);
                case PENDING:
                    return (<LockOutline color='disabled' style={styles.stateIcon}/>);
                case CURRENT_PENDING:
                    return (<PanoramaFishEye color='primary' style={styles.stateIcon}/>);
                default:
                    return '';
            }
        }

    }
}

const styles = ({
    stateIcon:{
        marginLeft: 20
    },
    loadingIndicator:{
        justifyContent: 'flex-start',
        width: 24,
        height: 24
    },
});



// WEBPACK FOOTER //
// ./src/overview/DayStateIcon.js